<app-loader *ngIf="loaderService.isLoadingState()"></app-loader>
<router-outlet></router-outlet>